// tslint:disable:member-ordering
// tslint:disable:no-namespace
// tslint:disable:max-classes-per-file
module ProcessList {
    import IModalService = angular.ui.bootstrap.IModalService;

    export class ProcessInstanceListController {
        public processInstances: ProcessInstanceDataViewModel;
        public allChecked: boolean;
        public initialDataLoaded: boolean = false;
        public selectedStateFilter: string;
        public selectedSortColumn: string;
        public selectedPageNumber: number;
        public selectedSortDirection: SortDirection;
        public retentionTimeInDays: number = 60;
        public dateTimeOptions;
        public availableStateFilters: string[];
        public startTimeLimit: Date = null;
        public endTimeLimit: Date = null;
        public latestProcessInstanceExecutionTime: moment.Moment = moment.utc().local();
        public timeLimit: number;
        public filterString: string;
        public isStartTimeOpen = false;
        public isEndTimeOpen = false;

        public newInstancesAvailable: boolean = false;
        public isFilterBarOpen: boolean = false;
        private localStorageBaseKey: string = "frends.hiddenColumns";

        public localStorageKey: string;
        private processCount: number;
        static $inject = ["ProcessInstanceListService", "$stateParams", "$state", "notifications", "$uibModal", "ProcessCountsService", "$rootScope", "$scope", "$timeout"];
        constructor(private processInstanceService: ProcessInstanceListService,
            private $stateParams: IProcessInstanceListStateParams,
            private $state: angular.ui.IStateService,
            private notifications: INotifications,
            private $modal: IModalService,
            private processCountsService: ProcessCountsService,
            $rootScope: ng.IRootScopeService,
            $scope: ng.IScope,
            private $timeout: ng.ITimeoutService) {
            this.availableStateFilters = Shared.getEnumNames(ProcessInstanceFilter);
            this.setInitialValuesFromStateParams();
            var cleanUpFunc = $rootScope.$on("processList.countsUpdated.frends", () => {

                if (this.initialDataLoaded) {
                    processCountsService.getLatestExecutionTimeForProcess(this.$stateParams.environmentName, this.$stateParams.agentGroupName, this.processInstances.processGuid)
                        .then(latestExecutionStartTime => {

                            // automatic list updates turned off for now for performance - ACC-6085
                            //if (latestExecutionStartTime && this.filtersAreEmpty(this.$state.params as IProcessInstanceListStateParams)) {
                            //    this.getInstanceData(true); //Disable spinner for periordical update
                            //}
                            ////if the process count has a 0-value then an update should always go trough since the count most likely was not initiated by the previous check.
                            //else if (!this.processCount || this.processCountsService.getCurrentExecutionCountForProcess(this.$stateParams.environmentName, this.processInstances.processGuid)!== this.processCount)
                            //{
                            //    this.getInstanceData(true); //Disable spinner for periordical update
                            //}
                            //else

                            if (latestExecutionStartTime) {
                                this.setNewInstancesAvailable(moment.utc(latestExecutionStartTime).local());
                            }

                        });
                }
            });

            $scope.$on('$destroy', function iVeBeenDismissed() {
                cleanUpFunc();
            })

            this.dateTimeOptions = {
                timePickerOptions: {
                    showMeridian: false, //24 hour format
                    defaultTime: '00:00:00'
                },
                datePickerOptions: {
                    showWeeks: false
                },
                buttonBar: {
                    show: true,
                    now: {
                        show: true,
                        text: FRENDS.Localizations.Now
                    },
                    today: {
                        show: true,
                        text: FRENDS.Localizations.Today
                    },
                    clear: {
                        show: false,
                        text: FRENDS.Localizations.Clear
                    },
                    date: {
                        show: true,
                        text: FRENDS.Localizations.Date
                    },
                    time: {
                        show: true,
                        text: FRENDS.Localizations.Time
                    },
                    close: {
                        show: true,
                        text: FRENDS.Localizations.Close
                    }
                }
            };
        }

        private setNewInstancesAvailable(latestExecutionTime: moment.Moment) {
            if (this.latestProcessInstanceExecutionTime < latestExecutionTime) {
                this.newInstancesAvailable = true;
                this.latestProcessInstanceExecutionTime = latestExecutionTime;
            }
        }

        private filtersAreEmpty(params: IProcessInstanceListStateParams): boolean {
            if (!params.page && !params.endTimeLimitUtc && !params.sortColumn && !params.stateFilter && !params.sortDirection && !params.startTimeLimitUtc) {
                return true;
            }
            return false;
        }

        private setInitialValuesFromStateParams() {
            if (this.processInstances) {
                this.retentionTimeInDays = this.processInstances.routineHistoryStorageDays ? this.processInstances.routineHistoryStorageDays : this.processInstances.defaultStorageDays;
            }
            this.timeLimit = this.$stateParams.timelimit != null ? this.$stateParams.timelimit : 7;
            if (parseInt(this.timeLimit as any) === 0)
                this.timeLimit = this.retentionTimeInDays;
            this.selectedStateFilter = this.$stateParams.stateFilter;
            this.selectedPageNumber = this.$stateParams.page;
            this.startTimeLimit = this.$stateParams.startTimeLimitUtc ? new Date(this.$stateParams.startTimeLimitUtc) : null;
            this.endTimeLimit = this.$stateParams.endTimeLimitUtc ? new Date(this.$stateParams.endTimeLimitUtc) : null;
            this.selectedSortColumn = this.$stateParams.sortColumn ? this.$stateParams.sortColumn : "Id";
            this.selectedSortDirection = this.$stateParams.sortDirection ? this.$stateParams.sortDirection : SortDirection.Descending;
            this.filterString = this.$stateParams.filterString;
            if (this.$stateParams.stateFilter || this.$stateParams.startTimeLimitUtc || this.$stateParams.endTimeLimitUtc) {
                this.toggleFilterBar(); //This toggles the filter bar and does a changeState that fetches the new data based on the state with the selected filters
            } else {
                this.getInstanceData();
            }
        }

        private get processInstanceQueryFilter(): IProcessInstanceQuery {
            let params = this.$state.params as IProcessInstanceListStateParams;
            return {
                environmentName: params.environmentName,
                agentGroupName: params.agentGroupName,
                processId: params.processId,
                timeLimit: params.timelimit || params.timelimit == 0 ? params.timelimit : 7,
                page: params.page,
                stateFilter: ProcessInstanceFilter[params.stateFilter],
                sortColumn: params.sortColumn,
                sortDirection: params.sortDirection,
                startTimeLimitUtc: params.startTimeLimitUtc,
                endTimeLimitUtc: params.endTimeLimitUtc,
                filterString: params.filterString,
            };
        }

        public toggleFilterBar() {
            this.isFilterBarOpen = !this.isFilterBarOpen;
            if (this.isFilterBarOpen) {
                this.selectedStateFilter = this.selectedStateFilter ? this.selectedStateFilter : ProcessInstanceFilter[ProcessInstanceFilter.ShowAll];
                this.startTimeLimit = this.startTimeLimit ? this.startTimeLimit : moment().subtract(this.timeLimit, "days").startOf('day').toDate();
                this.endTimeLimit = this.endTimeLimit ? this.endTimeLimit : moment().endOf('day').toDate();
                this.$timeout(() => { this.changeState() }, 200);
            } else {
                this.resetInstanceListFilter();
            }
        }

        public resetInstanceListFilter() {
            this.isFilterBarOpen = false;
            // Reset in timeout to give animation time to complete
            this.$timeout(() => {
                this.selectedStateFilter = null;
                this.startTimeLimit = null;
                this.endTimeLimit = null;
                this.selectedSortColumn = null;
                this.selectedSortDirection = null;
                this.selectedPageNumber = null;
                this.filterString = null;
                this.changeState()
            }, 200);
        }

        private processInstancesDeleteQueryFilter(processGuid: string, executionStates: ExecutionState[]): IProcessInstanceDeleteQuery {
            return {
                processGuid: processGuid,
                environmentName: this.$stateParams.environmentName,
                states: executionStates.map(x => ExecutionState[x])
            };
        }

        public toggleCheckAll() {
            this.processInstances.instances.forEach(p => p.checked = this.allChecked);
        };

        public uncheckAll() {
            this.allChecked = false;
            this.toggleCheckAll();
        };

        public getInstanceData(isSpinnerDisabled: boolean = false) {
            let currentQueryFilters = this.processInstanceQueryFilter;
            if (currentQueryFilters.processId != null) { //If the instance list has been closed the processId will be null. This can happen if you close the instance list while there is a then waiting to call getInstanceData
                this.processInstanceService.getProcessInstances(currentQueryFilters, isSpinnerDisabled).then(result => {
                    this.localStorageKey = this.localStorageBaseKey + result.data.processGuid;
                    this.processInstances = new ProcessInstanceDataViewModel(result.data, this.localStorageKey);

                    //Set instance indicator to false if the current request contains the newest instance
                    if (this.latestProcessInstanceExecutionTime && this.processInstances.instances.length > 0
                        && ((_.maxBy(this.processInstances.instances, x => x.startTimeUtc) || { startTimeUtc: null }).startTimeUtc >= this.latestProcessInstanceExecutionTime)) {
                        this.newInstancesAvailable = false;
                    }

                    // this initialization is probably not needed anymore?
                    this.processCountsService.getCurrentExecutionCountForProcess(
                        this.processInstanceQueryFilter.environmentName,
                        this.processInstanceQueryFilter.agentGroupName,
                        this.processInstances.processGuid).then(count => {
                            this.processCount = count;
                        });

                    this.initialDataLoaded = true;
                });
            }
        }


        public deleteAllSuccesful(processGuid: string) {
            this.deleteAllInstancesByState(this.processInstancesDeleteQueryFilter(processGuid, GroupedExecutionStates.SUCCESSFUL_STATES));
        }

        public deleteAllFinished(processGuid: string) {
            this.deleteAllInstancesByState(this.processInstancesDeleteQueryFilter(processGuid, GroupedExecutionStates.ALL_FINISHED_STATES));
        }

        private deleteAllInstancesByState(query: IProcessInstanceDeleteQuery) {
            this.deleteConfirmationModal().then(r =>
                this.processInstanceService.deleteAllProcessInstances(query).then(result => {
                    if (result.success) {
                        this.notifications.notify(result.data);
                        _.remove(this.processInstances.instances, (i) => _.findIndex(query.states, state => state === i.state) >= 0);
                    }
                }));
        }

        public acknowledgeAllErrors(processGuid: string) {
            var query: IProcessInstanceAcknowledgeAllQuery = {
                processGuid: processGuid,
                environmentName: this.$stateParams.environmentName,
                agentGroupName: this.$stateParams.agentGroupName
            }
            this.processInstanceService.acknowledgeAllErrors(query).then(result => {
                if (result.success) {
                    this.notifications.notify(result.data);
                    this.getInstanceData();
                }
            });
        }

        public getSelectedProcessInstances() {
            return _.filter(this.processInstances.instances, p => p.checked);
        };

        public deleteConfirmationModal() {
            var deleteConfirmationModal = this.$modal.open({
                templateUrl: 'deleteConfiramtionModalTemplate',
                windowClass: "default-modal-styles",
                resolve: {
                    itemType: () => FRENDS.Localizations.ProcessInstance,
                    itemName: () => ""
                },
                controller: Shared.DeleteConfirmationModalController,
                controllerAs: 'ctrl'
            });
            return deleteConfirmationModal.result;
        }

        public isErrorState(processInstanceState: string, acknowledgedUtc: string) {
            if (GroupedExecutionStates.ERROR_STATES.some(x => ExecutionState[x] == processInstanceState) && !acknowledgedUtc) {
                return true;
            }
        }

        public isRunningState(processInstanceState: string) {
            if (GroupedExecutionStates.RUNNING_STATES.some(x => ExecutionState[x] == processInstanceState)) {
                return true;
            }
        }

        public terminateInstance(instance: IInstance[]) {
            this.processInstanceService.terminateSelectedInstances(instance.map(x => x.executionId)).then(result => {
                if (result.success) {
                    this.notifications.notify(result.data);
                    this.getInstanceData();
                }
            })
        }
        public acknowledgeInstance(processGuid: string, instance: IInstance[]) {
            this.processInstanceService.acknowledgeSelectedInstances({
                environmentName: this.$stateParams.environmentName,
                processGuid: processGuid,
                instanceIds: instance.map(x => x.id)
            }).then(result => {
                if (result.success) {
                    this.notifications.notify(result.data);
                    this.getInstanceData();
                }
            })
        }
        public deleteInstance(processGuid: string, instance: IInstance[]) {
            this.deleteConfirmationModal().then(r => {
                var instanceIds = instance.map(x => x.id);
                this.processInstanceService.deleteSelectedInstances({
                    environmentName: this.$stateParams.environmentName,
                    processGuid: processGuid,
                    instanceIds: instanceIds
                }).then(result => {
                    if (result.success) {
                        this.notifications.notify(result.data);
                        _.remove(this.processInstances.instances, (i) => _.find(instanceIds, id => id === i.id) >= 0);
                    }
                })});
        }

        public nextPage() {
            if (this.processInstances.hasNextPage) {
                this.selectedPageNumber = this.processInstances.pageNumber + 1;
                this.changeState();
            }
        }

        public previousPage() {
            if (this.processInstances.hasPreviousPage) {
                this.selectedPageNumber = this.processInstances.pageNumber - 1;
                this.changeState();
            }
        }

        private changeState() {
            let params = this.$state.params as IProcessInstanceListStateParams;
            this.$state.transitionTo('environment.processInstanceList', {
                page: this.selectedPageNumber,
                processId: params.processId,
                environmentName: params.environmentName,
                agentGroupName: params.agentGroupName,
                timelimit: params.timelimit,
                processPage: params.processPage,
                filter: params.filter,
                reverseSort: params.reverseSort,
                orderByField: params.orderByField,
                stateFilter: this.selectedStateFilter,
                sortColumn: this.selectedSortColumn,
                sortDirection: this.selectedSortDirection,
                startTimeLimitUtc: this.startTimeLimit ? this.startTimeLimit.toJSON() : "",
                endTimeLimitUtc: this.endTimeLimit ? this.endTimeLimit.toJSON() : "",
                filterString: this.filterString
            }, { notify: false }).then(result => this.getInstanceData());
        }

        private changeTimeLimit() {
            let params = this.$state.params as IProcessInstanceListStateParams;
            var convertedStart = params.startTimeLimitUtc != null ? new Date(params.startTimeLimitUtc).getTime() : "";
            var convertedEnd = params.endTimeLimitUtc != null ? new Date(params.endTimeLimitUtc).getTime() : "";
            var start = this.startTimeLimit != null ? this.startTimeLimit.getTime() : "";
            var end = this.endTimeLimit != null ? this.endTimeLimit.getTime() : "";
            if (start !== convertedStart || end !== convertedEnd) {
                this.changeState();
            }
        }

        public setFilterString() {
            this.changeState();
        }

        public setStateFilter(state: string) {
            this.selectedStateFilter = state;
            this.changeState();
        }

        public changeSorting(column: string) {
            if (this.selectedSortColumn == column) {
                this.selectedSortDirection == SortDirection.Ascending ? this.selectedSortDirection = SortDirection.Descending : this.selectedSortDirection = SortDirection.Ascending;
            } else {
                this.selectedSortColumn = column;
                this.selectedSortDirection = SortDirection.Descending;
            }
            this.changeState();
        };

        public saveColumnsToLocalStorage() {
            localStorage.setItem(this.localStorageKey, JSON.stringify(this.processInstances.hiddenColumns));
        };

        public isColumnVisible(columnName: string): boolean {
            return this.processInstances.hiddenColumns.some(x => x == columnName) ? false : true;
        }

        public changeColumnVisibility(columnName: string) {
            var index = this.processInstances.hiddenColumns.indexOf(columnName);
            if (index > -1) {
                this.processInstances.hiddenColumns.splice(index, 1);
            } else {
                this.processInstances.hiddenColumns.push(columnName);
            }
            this.saveColumnsToLocalStorage();
        }
    }

    class ProcessInstanceDataViewModel {
        processId: number;
        processGuid: string;
        routineHistoryStorageDays: number;
        defaultStorageDays: number;
        promotedColumnNames: string[];
        pageNumber: number;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        instances: Array<ProcessInstance>;
        itemsPerPage: number;
        isExceptions: boolean;
        localStorageKey: string;
        hiddenColumns: string[];
        allColumns: IColumn[] =
        [
            { key: "state", display: FRENDS.Localizations.State, isPromoted: false },
            { key: "id", display: FRENDS.Localizations.Id, isPromoted: false },
            { key: "processVersion", display: FRENDS.Localizations.Version, isPromoted: false },
            { key: "startTimeUtc", display: FRENDS.Localizations.StartTime, isPromoted: false },
            { key: "duration", display: FRENDS.Localizations.Duration, isPromoted: false },
            { key: "triggerName", display: FRENDS.Localizations.Trigger, isPromoted: false },
            { key: "agentName", display: FRENDS.Localizations.Agent, isPromoted: false },
            { key: "exception", display: FRENDS.Localizations.ErrorInfo, isPromoted: false },
            { key: "triggerRequest", display: FRENDS.Localizations.ProcessParameters, isPromoted: false },
            { key: "triggerResponse", display: FRENDS.Localizations.ProcessReturnValues, isPromoted: false }
        ];
        defaultColumnsToHide: string[] = ["id", "processVersion", "triggerName", "agentName", "triggerRequest", "triggerResponse"];
        constructor(data: IProcessInstanceData, _localStorageKey: string) {
            this.localStorageKey = _localStorageKey;
            this.defaultStorageDays = data.defaultStorageDays;
            this.routineHistoryStorageDays = data.routineHistoryStorageDays;
            this.processGuid = data.processGuid;
            this.processId = data.processId;
            this.pageNumber = data.paginationViewModel.pageNumber;
            this.hasNextPage = data.paginationViewModel.hasNextPage;
            this.hasPreviousPage = data.paginationViewModel.hasPreviousPage;
            this.itemsPerPage = data.itemsPerPage;
            this.instances = data.paginationViewModel.instances.map(instance => new ProcessInstance(instance));

            //Get the unique column names from all the visible instances
            this.promotedColumnNames =
                _.uniq(
                    _.flatten(
                        this.instances.map(x => _.isEmpty(x.promotedColumns) ? [] : Object.keys(x.promotedColumns))));

            //Add the promoted column names to the list of all columns
            this.promotedColumnNames.forEach(x =>
                this.allColumns.push({ key: x, display: x, isPromoted: true })
            );

            this.isExceptions = this.instances != null && this.instances.some(x => x.exception != null);
            this.hiddenColumns = this.hiddenColumnsFromLocalStorage;
        }

        private get hiddenColumnsFromLocalStorage(): string[] {
            const savedColumns = localStorage.getItem(this.localStorageKey);
            if (savedColumns) {
                return JSON.parse(savedColumns);
            } else {
                return this.defaultColumnsToHide;
            }
        }
    }

    class ProcessInstance {
        checked: boolean;
        executionId: string;
        id: number;
        exception: string;
        triggerRequest: string;
        triggerResponse: string;
        startTimeUtc: moment.Moment;
        endTimeUtc: moment.Moment;
        detailedDuration: string;
        duration: string;
        promotedColumns: IGroupedPromotedColumn
        acknowledgedUtc: string;
        state: string;
        triggerName: string;
        agentName: string;
        processVersion: string;
        constructor(data: IInstance) {
            this.startTimeUtc = data.startTimeUtc ? moment.utc(data.startTimeUtc).local() : null;
            this.endTimeUtc = data.endTimeUtc ? moment.utc(data.endTimeUtc).local() : moment.utc().local();
            this.id = data.id;
            this.exception = data.exception;
            this.triggerRequest = data.triggerRequest;
            this.triggerResponse = data.triggerResponses;
            this.executionId = data.executionId;
            this.acknowledgedUtc = data.acknowledgedUtc;
            this.state = data.state;
            this.triggerName = data.triggerName;
            this.agentName = data.agentName;
            this.processVersion = data.processVersion;
            this.promotedColumns = _.groupBy(data.promotedColumns, (x) => x.name);

            if (this.state !== ExecutionState[ExecutionState.Started] && this.startTimeUtc != null) {
                this.detailedDuration = this.getDetailedDuration;
                this.duration = this.getDuration;
            }
        }

        public getFormattedJson(str: string) {
            if (str) {
                return `<pre>${angular.toJson(this.getAsObj(str), true)}</pre>`;
            }
            return null;
        }

        private getAsObj(value: any) {
            // if it's a string that seems to contain a json object or an array, attempt to parse it:
            if (_.isString(value) && (value.trim().startsWith("{") || value.trim().startsWith("["))) {
                try {
                    const val = JSON.parse(value);
                    return this.getAsObj(val);
                } catch (exception) {
                    // Do nothing, continue with the unparsed value
                }
            }
            if (_.isArray(value)) {
                return value.map((v) => this.getAsObj(v));
            }
            if (_.isObject(value)) {
                return _.mapValues(value, (v) => this.getAsObj(v));
            }
            return value;
        }

        public get getDetailedDuration() {
            var ms = this.endTimeUtc.diff(this.startTimeUtc);
            return moment.duration(ms).format("HH:mm:ss.SSS");
        };

        public get getDuration() {
            var ms = this.endTimeUtc.diff(this.startTimeUtc);
            return moment.duration(ms).format("m[m] s[s]");
        };
    }

    interface IProcessInstanceListStateParams {
        processId: number;
        environmentName: string;
        agentGroupName: string;
        timelimit?: number;
        page?: number;
        stateFilter?: string;
        sortColumn?: string;
        sortDirection?: SortDirection;
        startTimeLimitUtc?: string;
        endTimeLimitUtc?: string;
        filterString?: string;
        filter?: string;
        processPage?: string;
        reverseSort?: boolean;
        orderByField?: string;

    }

    export interface IProcessInstanceData {
        processId: number;
        processGuid: string;
        routineHistoryStorageDays: number;
        defaultStorageDays: number;
        itemsPerPage: number;
        paginationViewModel: IPaginationViewModel;
    }

    interface IPaginationViewModel {
        instances: IInstance[];
        pageNumber: number;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
    }

    interface IInstance {
        executionId: string;
        id: number;
        exception: string;
        triggerRequest?: string;
        triggerResponses?: string;
        startTimeUtc: string;
        endTimeUtc: string;
        promotedColumns: IPromotedColumn[];
        acknowledgedUtc;
        state;
        triggerName;
        agentName;
        processVersion;
    }

    interface IPromotedColumn {
        name: string;
        value: string;
    }

    interface IGroupedPromotedColumn {

    }

    interface IColumn {
        key: string;
        display: string;
        isPromoted: boolean;
    }


    module.controller("ProcessInstanceListController", ProcessInstanceListController);
}